// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.successContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.successCard {
  background-color: white;
  border-radius: 10px;
  padding: 40px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
  text-align: center;
}

.successTitle {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.successIcon {
  margin: 20px auto;
}

.paymentDetails {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.detailRow {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.detailRow:last-child {
  border-bottom: none;
}

.detailLabel {
  font-weight: bold;
  color: #666;
}

.detailValue {
  color: #333;
}

.successMessage {
  margin: 20px 0;
  line-height: 1.5;
  color: #555;
}

.dashboardButton {
  width: 100%;
  height: 50px;
  padding: 12px;
  background-color: #FF6F0F;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 20px;
}

.dashboardButton:hover {
  background-color: #E56000;
}

.payment-success-container {
  width: 100%;
  height: 100vh;
  display: flex;
  position: relative;
  background-color: white;
}

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  z-index: 2;
}

/* 체크 아이콘 */
.check-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #FF8F45;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

/* 성공 메시지 */
.success-message {
  font-size: 28px;
  font-weight: bold;
  color: #000;
  margin: 0;
  margin-bottom: 10px;
}

/* 회사 코드 메시지 */
.company-code-message {
  font-size: 18px;
  color: #000;
  margin: 40px 0;
}

.company-code {
  font-weight: bold;
}

/* 관리자 페이지로 이동 버튼 */
.admin-page-button {
  padding: 15px 50px;
  border: 1px solid #FF8F45;
  border-radius: 5px;
  background-color: transparent;
  color: #FF8F45;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.admin-page-button:hover {
  background-color: rgba(255, 143, 69, 0.1);
}

/* 에러 메시지 스타일 */
.error-message {
  color: #D32F2F;
  background-color: #FFEBEE;
  padding: 15px;
  border-radius: 5px;
  margin: 20px 0;
  max-width: 500px;
  width: 100%;
  text-align: center;
  border: 1px solid #FFCDD2;
}

/* 결제 금액 스타일 */
.payment-amount {
  font-size: 18px;
  color: #000;
  margin: 20px 0 10px;
}

.amount {
  font-weight: bold;
  color: #FF8F45;
}

/* 플랜 정보 스타일 */
.plan-info {
  font-size: 18px;
  color: #000;
  margin: 10px 0 30px;
}

.plan-period {
  font-weight: bold;
  color: #333;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .green-line {
    right: 50px;
  }
  
  .success-message {
    font-size: 22px;
  }
  
  .company-code-message {
    font-size: 16px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/PaymentSuccess.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".successContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.successCard {\n  background-color: white;\n  border-radius: 10px;\n  padding: 40px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  width: 100%;\n  text-align: center;\n}\n\n.successTitle {\n  font-size: 28px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.successIcon {\n  margin: 20px auto;\n}\n\n.paymentDetails {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px 0;\n}\n\n.detailRow {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.detailRow:last-child {\n  border-bottom: none;\n}\n\n.detailLabel {\n  font-weight: bold;\n  color: #666;\n}\n\n.detailValue {\n  color: #333;\n}\n\n.successMessage {\n  margin: 20px 0;\n  line-height: 1.5;\n  color: #555;\n}\n\n.dashboardButton {\n  width: 100%;\n  height: 50px;\n  padding: 12px;\n  background-color: #FF6F0F;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: bold;\n  margin-top: 20px;\n}\n\n.dashboardButton:hover {\n  background-color: #E56000;\n}\n\n.payment-success-container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  position: relative;\n  background-color: white;\n}\n\n.success-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  z-index: 2;\n}\n\n/* 체크 아이콘 */\n.check-icon {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background-color: #FF8F45;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n/* 성공 메시지 */\n.success-message {\n  font-size: 28px;\n  font-weight: bold;\n  color: #000;\n  margin: 0;\n  margin-bottom: 10px;\n}\n\n/* 회사 코드 메시지 */\n.company-code-message {\n  font-size: 18px;\n  color: #000;\n  margin: 40px 0;\n}\n\n.company-code {\n  font-weight: bold;\n}\n\n/* 관리자 페이지로 이동 버튼 */\n.admin-page-button {\n  padding: 15px 50px;\n  border: 1px solid #FF8F45;\n  border-radius: 5px;\n  background-color: transparent;\n  color: #FF8F45;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.admin-page-button:hover {\n  background-color: rgba(255, 143, 69, 0.1);\n}\n\n/* 에러 메시지 스타일 */\n.error-message {\n  color: #D32F2F;\n  background-color: #FFEBEE;\n  padding: 15px;\n  border-radius: 5px;\n  margin: 20px 0;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n  border: 1px solid #FFCDD2;\n}\n\n/* 결제 금액 스타일 */\n.payment-amount {\n  font-size: 18px;\n  color: #000;\n  margin: 20px 0 10px;\n}\n\n.amount {\n  font-weight: bold;\n  color: #FF8F45;\n}\n\n/* 플랜 정보 스타일 */\n.plan-info {\n  font-size: 18px;\n  color: #000;\n  margin: 10px 0 30px;\n}\n\n.plan-period {\n  font-weight: bold;\n  color: #333;\n}\n\n/* 반응형 스타일 */\n@media (max-width: 768px) {\n  .green-line {\n    right: 50px;\n  }\n  \n  .success-message {\n    font-size: 22px;\n  }\n  \n  .company-code-message {\n    font-size: 16px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
